// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__4HALL","upload":"Small_upload__GfrWD","imageWrap":"Small_imageWrap__HsdPi","removeBtn":"Small_removeBtn__2bXl1"};